import { Component, OnInit } from '@angular/core';
import { RouterLinkInfoService } from 'src/app/services/router-link-info.service';

@Component({
  selector: 'app-item-tracker-master',
  templateUrl: './item-tracker-master.component.html',
  styleUrls: ['./item-tracker-master.component.css']
})
export class ItemTrackerMasterComponent implements OnInit {

  constructor(private routerinfoservice: RouterLinkInfoService) { }

  ngOnInit(): void {
  }
  onActivate(componentRef) {
    try {
      var currentUrl = window.location.pathname;
      // var me =  componentRef.getPageName();
      // this.CData =me;
      $('#breadItem').text(this.routerinfoservice.getPageName(currentUrl));
    }
    catch (ex) {
      console.log('Not set');
    }
  }

}
